// Components==============
import NavigationBox from 'components/Layout/NavigationBox/NavigationBox';
import React, { useContext, useEffect } from 'react';
import { getTilePosition } from 'utilities/getTilePosition';
import { usePrevious } from 'utilities/usePrevious';
import { HomeContext } from '../Home';
import { texts, titles } from './SequenceContent';
// =========================

export default function WelcomeSequence() {
    const {
        setWelcomeSequence,
        welcomeSequence,
        welcomeDisplayMode,
        welcomeRight,
        welcomeLeft,
        welcomeTop,
        welcomeX,
        welcomeY,
        setWelcomeTop,
        setWelcomeRight,
        setWelcomeLeft,
        setWelcomeX,
        setWelcomeY,
        handleZoom,
        currentTile,
        setCurrentTile,
    } = useContext(HomeContext);

    const previousSequence = () => {
        const keys = Object.keys(titles) as WelcomeSequenceOptions[];
        const prevIndex = keys.indexOf(welcomeSequence) - 1;
        const prevItem = keys[prevIndex];
        setWelcomeSequence(prevItem);
    };

    const nextSequence = () => {
        const keys = Object.keys(titles) as WelcomeSequenceOptions[];
        const nextIndex = keys.indexOf(welcomeSequence) + 1;
        const nextItem = keys[nextIndex];
        setWelcomeSequence(nextItem);
    };

    const closeSequence = () => {
        setWelcomeSequence('initial');
        setWelcomeTop('2em');
        setWelcomeRight('50%');
        setWelcomeX('50%');
        setWelcomeY('0');
    };

    const previousValue = usePrevious(welcomeSequence);

    useEffect(() => {
        const zoomNTimes = (n: number) => Array.from(Array(n).keys());
        if (welcomeSequence === 'welcome') {
            setWelcomeTop('2em');
            setWelcomeRight('50%');
            setWelcomeX('50%');
            const { originX, originY } = getTilePosition(currentTile.ref);
            setCurrentTile((prev) => ({ ...prev, originX, originY }));

            setTimeout(() => {
                zoomNTimes(10).forEach(() => handleZoom({ direction: 1 }));
            }, 1);
        }
        if (previousValue === 'welcome' && welcomeSequence === 'klankenkaart')
            zoomNTimes(5).forEach(() => handleZoom({ direction: -1 }));

        if (welcomeSequence === 'wereldkaart') {
            setWelcomeLeft('');
            setWelcomeTop('50%');
            setWelcomeRight('50%');
            setWelcomeX('50%');
            setWelcomeY('-50%');
        }
    }, [welcomeSequence]);

    return (
        <NavigationBox
            displayMode={welcomeDisplayMode}
            top={welcomeTop}
            right={welcomeRight}
            left={welcomeLeft}
            x={welcomeX}
            y={welcomeY}
            title={titles[welcomeSequence]}
            text={texts[welcomeSequence]}
            audio={`/audio/welcomeSequence/${welcomeSequence}.mp3`}
            previous={
                welcomeSequence === 'welcome' ? undefined : previousSequence
            }
            next={
                welcomeSequence === 'spaceWoorden'
                    ? closeSequence
                    : nextSequence
            }
            image={
                welcomeSequence === 'spiekstad'
                    ? '/images/welcomeSequenceTiles/ondergrond-stad.svg'
                    : welcomeSequence === 'klinker'
                    ? '/images/welcomeSequenceTiles/ondergrond-gras.svg'
                    : welcomeSequence === 'medeklinker'
                    ? '/images/welcomeSequenceTiles/ondergrond-water.svg'
                    : welcomeSequence === 'wondereWoorden'
                    ? '/images/welcomeSequenceTiles/ondergrond-woestijn.svg'
                    : welcomeSequence === 'spaceWoorden'
                    ? '/images/welcomeSequenceTiles/ondergrond-space.svg'
                    : ''
            }
            animations
        />
    );
}
